import { useAuth } from '@/contexts/AuthContext'
import { Button } from '@/components/ui/button'
import { ThemeToggle } from '@/components/ThemeToggle'
import { LogOut, User, Shield, Crown } from 'lucide-react'

export function Header() {
  const { user, logout } = useAuth()

  const getRoleIcon = (role: string) => {
    switch (role) {
      case 'Admin':
        return <Crown size={14} className="text-primary" />
      case 'Editor':
        return <Shield size={14} className="text-primary" />
      default:
        return <User size={14} className="text-muted-foreground" />
    }
  }

  const getRoleBadge = (role: string) => {
    const baseClasses = "px-2 py-1 text-xs rounded-full font-medium"
    switch (role) {
      case 'Admin':
        return `${baseClasses} bg-primary/10 text-primary`
      case 'Editor':
        return `${baseClasses} bg-primary/10 text-primary`
      default:
        return `${baseClasses} bg-muted text-muted-foreground`
    }
  }

  return (
    <header className="bg-background shadow-sm border-b border-border">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center space-x-4">
          <h2 className="text-xl font-semibold text-foreground">
            Admin Dashboard
          </h2>
        </div>

        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <User size={16} />
              <span>{user?.email}</span>
            </div>
            
            {user?.role && (
              <div className="flex items-center space-x-1">
                {getRoleIcon(user.role)}
                <span className={getRoleBadge(user.role)}>
                  {user.role}
                </span>
              </div>
            )}
          </div>
          
          <ThemeToggle />
          
          <Button
            onClick={logout}
            variant="outline"
            size="sm"
            className="flex items-center space-x-2"
          >
            <LogOut size={16} />
            <span>Logout</span>
          </Button>
        </div>
      </div>
    </header>
  )
}